import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  ActionButton,
  Backdrop,
  Circle,
  CircleCheck,
  Appointment,
} from "../../components/Themed.js";
import { getVariations } from "../../data/service/ServiceActions.js";
import { confirmAppointment } from "../../data/appointment/AppointmentActions.js";
import { getEmployeeName } from "../../data/employee/EmployeeReducer";
import "./Bookings.css";
import moment from "moment-timezone";
import { t } from "../../locales";

class Bookings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedAppointments: [],
    };

    this.appointmentClick = this.appointmentClick.bind(this);
    this.renderAppointment = this.renderAppointment.bind(this);
    this.confirmClick = this.confirmClick.bind(this);
  }

  async componentDidMount() {
    const { getVariations, variations } = this.props;

    if (!variations || variations.length === 0) {
      await Promise.all([getVariations()]);
    }
  }

  appointmentClick(appointmentId) {
    if (this.state.selectedAppointments.indexOf(appointmentId) > -1) {
      this.setState({
        selectedAppointments: this.state.selectedAppointments.filter(
          (a) => a !== appointmentId
        ),
      });
    } else {
      this.setState({
        selectedAppointments: this.state.selectedAppointments.concat(
          appointmentId
        ),
      });
    }
  }

  async confirmClick() {
    const { confirmAppointment, history, bookings } = this.props;
    const promises = [];

    if (bookings.length > 1) {
      this.state.selectedAppointments.forEach((sa) =>
        promises.push(confirmAppointment(sa))
      );
    } else {
      promises.push(confirmAppointment(bookings[0].id));
    }

    Promise.all(promises).then((res) => {
      if (res) {
        history.push("/confirmation");
      }
    });
  }

  renderAppointment(appointment, showCheckMark) {
    const selected =
      this.state.selectedAppointments.indexOf(appointment.id) > -1;

    const { variations, location, employees } = this.props;
    const variationNames = appointment.slot_variations
      .map((sv) => variations.filter((v) => v.id === sv.variation_id)[0].name)
      .join(" and ");

    const description =
      variationNames +
      " | " +
      moment(appointment.begin_at)
        .tz(location.time_zone)
        .format("h:mm A");

    const employeeName = getEmployeeName(appointment.employee_id, employees);

    return (
      <Appointment
        key={appointment.id}
        onClick={() => this.appointmentClick(appointment.id)}
      >
        {showCheckMark && (
          <div
            style={{
              position: "absolute",
              top: "0px",
              bottom: "0px",
              left: "10px",
              width: "90px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Circle style={{ position: "static", paddingTop: "4px" }}>
              <CircleCheck
                className="fas fa-check"
                style={{
                  opacity: selected ? 1 : 0,
                  position: "static",
                }}
              />
            </Circle>
          </div>
        )}
        <div
          className="bookings-appointment-title"
          style={{ paddingLeft: showCheckMark ? "90px" : null }}
        >
          {appointment.child_label
            ? appointment.child_label
            : appointment.client_name}
        </div>
        {employeeName && (
          <div className="bookings-appointment-staff-name">{employeeName}</div>
        )}
        <div
          className="bookings-appointment-text"
          style={{ paddingLeft: showCheckMark ? "90px" : null }}
        >
          {description}
        </div>
      </Appointment>
    );
  }

  render() {
    const { clientInformation, variations, bookings } = this.props;
    if (!variations || variations.length === 0) return null;

    const firstName = clientInformation.first_name;
    const selectedCount = this.state.selectedAppointments.length;
    const showCheckMark = bookings ? bookings.length > 1 : false;

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="bookings-title">
              {t("booking.welcome")}, {firstName}!
            </div>
            <div className="content">
              {bookings &&
                bookings.map((a) => this.renderAppointment(a, showCheckMark))}

              <div style={{ height: "40px" }} />
              {bookings && bookings.length === 1 && (
                <ActionButton onClick={this.confirmClick}>
                  {t("booking.check_in")}
                </ActionButton>
              )}
            </div>
          </div>
        </div>
        {bookings && bookings.length > 1 && selectedCount > 0 && (
          <div className="bookings-controls">
            <div className="bookings-controls-summary">
              {selectedCount}{" "}
              {selectedCount > 1
                ? t("booking.member_selected_plural")
                : t("booking.member_selected")}
            </div>

            <ActionButton
              onClick={this.confirmClick}
              className="bookings-controls-button"
            >
              {t("booking.continue")}
            </ActionButton>
          </div>
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    location: state.app.location,
    clientInformation: state.client.clientInformation,
    variations: state.service.variations, // Not only bookable
    bookings: state.appointment.bookings,
    employees: state.employee.employees,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getVariations,
    confirmAppointment,
  })(Bookings)
);
